export default __webpack_public_path__ + "static/explore_1-979027eaa966f615445a552ea338a564.png";